import LinkNoPrefetch from '@/components/link-noprefetch';

function Tag({
    fontColor = 'text-fuschia-800',
    bgColor = 'bg-fuschia-100',
    children,
    hrefMode,
    text,
    categories,
    adaptedValue
}) {
    const style = `${fontColor} ${bgColor} flex w-fit items-center justify-center rounded-full`;
    const TagContent = <div className={style}>{children}</div>;

    return hrefMode ? (
        <LinkNoPrefetch
            className={style}
            href={`/blog${categories ? '/' : '?tag='}${adaptedValue || text}`}>
            {TagContent}
        </LinkNoPrefetch>
    ) : (
        TagContent
    );
}

export default Tag;
